import { render, staticRenderFns } from "./OrgLeadsStatsByType.vue?vue&type=template&id=23eee0de&scoped=true&"
import script from "./OrgLeadsStatsByType.vue?vue&type=script&lang=js&"
export * from "./OrgLeadsStatsByType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eee0de",
  null
  
)

export default component.exports